/**
 * 系统角色 —— **登录用户的职能**，决定这个人能改哪些模块。
 *
 * 不要与 `CHARGE_ROLE` 混淆：那是 SAP 带回来的**担当人员快照**（印在 Tech Pack 页眉），
 * 存在每张委托书自己的 `ds_charge` 上，与登录用户无关。
 * 详见 `docs/user-roles-and-approval-plan.md` 第一节。
 *
 * 角色本身以数据形式存放在 `sys_role` 表中，这里定义的是内置角色的 code，
 * 代码里按角色判断时引用这些常量，不要硬编码字符串。
 *
 * **一人一角色**（2026-09-22）：`sys_user.role_id` 单外键，不再是多对多。
 */
export const ROLE = {
    /** 系统管理员：全部权限，含用户管理 */
    ADMIN: 'ADMIN',
    /** 设计室长：审批设计师提交的设计内容 */
    APPROVER: 'APPROVER',
    /** 设计师：填写设计相关模块并提交审批 */
    DESIGNER: 'DESIGNER',
    /** 生产管理：面料信息（含面料采购的全部范围）+ Tech Pack 查看下载 + QC */
    PRODUCTION: 'PRODUCTION',
    /** 面辅料采购：面料信息、面辅料单价、辅料库维护 */
    FABRIC: 'FABRIC',
    /** 版师：录入单耗（用量）、基准尺寸与尺寸偏差 */
    PATTERN: 'PATTERN',
    /** 商品企划：前序推送、负责人分工与在线商品信息 */
    PLANNER: 'PLANNER',
    /** 只读：仅可查看 */
    VIEWER: 'VIEWER',
};
export const ROLE_LABELS = {
    [ROLE.ADMIN]: { zh: '系统管理员', ko: '시스템 관리자' },
    [ROLE.APPROVER]: { zh: '设计室长', ko: '디자인 실장' },
    [ROLE.DESIGNER]: { zh: '设计师', ko: '디자이너' },
    [ROLE.PRODUCTION]: { zh: '生产管理', ko: '생산관리' },
    // 显示名 09-25 由「面料采购」改为「面辅料采购」：这个角色实际管面料和辅料（辅料库也归它），代码不动
    [ROLE.FABRIC]: { zh: '面辅料采购', ko: '원부자재 구매' },
    [ROLE.PATTERN]: { zh: '版师', ko: '패턴사' },
    [ROLE.PLANNER]: { zh: '商品企划', ko: '상품기획' },
    [ROLE.VIEWER]: { zh: '只读用户', ko: '조회 전용' },
};
/** 角色在画面上的排列顺序（按职责链，不按字母） */
export const ALL_ROLE_CODES = Object.values(ROLE);
//# sourceMappingURL=roles.js.map